/**
 * GraphQL query for assigning moderation cases to a moderator
 */

import { gql } from '@apollo/client';

export const ASSIGN_MODERATION_CASE = gql`
  query AssignModerationCase($communityId: ID!, $topicName: String!) {
    assignModerationCase(communityId: $communityId, topicName: $topicName) {
      id
      communityId
      topicName
      subjectId
      caseId
      pk
      report {
        communityId
        topicName
        subjectId
        timestamp
        feedbackComment
        feedbackLabels
        contents {
          contentId
          contentType
          data
          humanModerationViewHeader
          labels {
            labels {
              name
              confidence
            }
            source
          }
        }
        reportSource {
          id
          type
        }
        subjectOwner {
          id
          type
          additionalInfo {
            key
            value
          }
        }
      }
      status
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
    }
  }
`;
